import { t } from "@lingui/macro"
import { Grid, InputAdornment, useTheme } from "@mui/material"
import { memo, useMemo } from "react"

import { IContractListHeaderProps } from "src/views/contracts/pages/list/types/contract-list"

import { StyledContractList } from "src/views/contracts/pages/list/styled"

import { Search24 } from "src/components/icons/Search24"
import { SegmentPickerButton } from "src/components/SegmentPickerButton"

export const ContractListHeader = memo(
    ({
        search,
        segments,
        onSearch,
        onSegmentChange,
        onExportCsv,
        isSmallScreen,
    }: IContractListHeaderProps) => {
        const theme = useTheme()

        const searchFieldInputProps = {
            startAdornment: (
                <InputAdornment
                    position="start"
                    sx={{ color: theme.palette.grey[900] }}
                >
                    <Search24 />
                </InputAdornment>
            ),
            type: "search",
        }

        const exportButton = useMemo(
            () => (
                <StyledContractList.ActionButton
                    onClick={onExportCsv}
                    color="info"
                    variant="outlined"
                    sx={{
                        width: {
                            sm: "fit-content",
                        },
                        ml: 2,
                    }}
                    data-testid="export-orders-button"
                >
                    {t`contracts-list-view.export-all-csv`}
                </StyledContractList.ActionButton>
            ),
            [onExportCsv],
        )

        return (
            <StyledContractList.HeaderContainer container>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    <StyledContractList.SearchField
                        value={search ?? ""}
                        placeholder={t`contracts-list-view.search-placeholder`}
                        title={t`contracts-list-view.search-placeholder`}
                        onChange={onSearch}
                        size="small"
                        InputProps={searchFieldInputProps}
                        data-testid="tenant-search"
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                    {Boolean(isSmallScreen) ? (
                        <Grid container>
                            <Grid item xs={0} sm={0} md={0} lg={6} xl={6} />
                            <StyledContractList.ButtonsContainer
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={4}
                                xl={4}
                            >
                                <SegmentPickerButton
                                    value={segments}
                                    onChange={onSegmentChange}
                                />
                            </StyledContractList.ButtonsContainer>
                            {exportButton}
                        </Grid>
                    ) : (
                        <StyledContractList.ButtonContainerLargeScreen>
                            <SegmentPickerButton
                                value={segments}
                                onChange={onSegmentChange}
                            />
                            {exportButton}
                        </StyledContractList.ButtonContainerLargeScreen>
                    )}
                </Grid>
            </StyledContractList.HeaderContainer>
        )
    },
)
